import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonIconComponent } from '@ui-kit/buttons';

@Component({
    selector: 'card',
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonIconComponent],
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
    id = input.required<string>();
    header = input<string>('');
    icon = input<string>('');
    iconColor = input<string>('var(--card-header-color)');
    customHeader = input<boolean>(false);

    hasRefreshButton = input<boolean>(false);
    refreshButtonLabel = input<string>('');

    refreshButton = output<void>();
}
